export const SEARCH_INPUT_WIDTH = 340

export const BOTTOM_APPBAR_TRANSITION_DURATION = 300
